
import React, { useState, useEffect } from 'react';
import { Form, Button, Steps, Icon, Tooltip, InputNumber, Input, Radio, Select, Card, Descriptions, Checkbox } from 'antd';
import { Text1, Text4 } from '../../../../../styles';
import { TdsChallan } from "../../../../../models";
import { alertify, handleApiExceptions, printRupee } from '../../../../../app_methods';
import { AccountCard } from './styles';
import { CHALLAN_NUMBER_CHOICES, MAJOR_HEAD_CHOICES, MINOR_HEAD_CHOICES, ASSESSMENT_YEAR } from '../../../../TaxPayments/DirectTax/constants';
import { getBankLogo } from '../../../../../constants';
import './index.scss';

const { Option } = Select;


let DirectTaxForm = (props) => {
    const { form, direct_tax } = props;
    const { getFieldDecorator } = form;
    const [currentStep, setCurrentStep] = useState(0);
    const validations = TdsChallan.validations;
    const [taxCatgories, setTaxCatgories] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [virtualAccounts, setVirtualAccounts] = useState([]);

    const fetchDirectTaxTAXCategories = async () => {
        const direct_tax_challan = new TdsChallan()
        const response = await direct_tax_challan.fetchDirectTaxTAXCategories()
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        setTaxCatgories(response.data.direct_tax_categories);
    }

    const createDirectTaxChallan = async (values) => {
        setIsSaving(true)
        const response = await TdsChallan.create({ ...values })
        if (!response.success) {
            setIsSaving(false)
            handleApiExceptions(response);
            return;
        }
        handleSaveResponse(values, response)
    }

    const updateDirectTaxChallan = async (values) => {
        setIsSaving(true)
        const response = await direct_tax.update({ ...values })
        if (!response.success) {
            setIsSaving(false)
            handleApiExceptions(response);
            return;
        }
        handleSaveResponse(values, response)
    }

    const handleSaveResponse = (values, response) => {
        setIsSaving(false);

        const is_approval_flow = response.data.direct_tax.current_challan_approval ? true : false;
        if (!values.initiate_payment) {
            alertify("Success", `Direct Tax challan ${direct_tax.is_edit ? "updated" : "created"} successfully.`, "success");
        }
        else {
            if (response.data.payment_initated) {
                alertify("Success", `Direct Tax challan ${direct_tax.is_edit ? "updated" : "saved"}. ${response.data.payment_message || "Payment initated successfully."}`, "success")
            }
            else {
                if (is_approval_flow) {
                    alertify("Success", `Direct Tax challan saved. Payment can be initiated after approval.`, "info")
                }
                else {
                    alertify("Success", `Direct Tax challan saved. Payment failed.`, response.data.message, "info")
                }
            }
        }

        props.fetchChallanList()
        props.toggleDirectTaxChallanModal()
    }
    const onSubmit = (e) => {
        form.validateFields((err, values) => {
            if (err) return;
            if (direct_tax.is_edit) {
                updateDirectTaxChallan(values)
            } else {
                createDirectTaxChallan(values)
            }
        })

    }


    const renderAccounts = () => {
        return (
            <Select placeholder="Select Virtual Account">
                {virtualAccounts ?
                    virtualAccounts.map((account, index) =>
                        <Select.Option value={account.id} >
                            {console.log(account)}
                            <div className="d-flex">
                                <div
                                    style={{
                                        display: "flex",
                                        width: 28,
                                        overflow: "hidden",
                                        textAlign: "center",
                                        marginRight: 8
                                    }}
                                >
                                    <img
                                        style={{
                                            margin: "auto",
                                            width: "auto",
                                            maxWidth: "100%",
                                            maxHeight: 28
                                        }}
                                        alt=""
                                        src={getBankLogo(account.provider_code)}
                                    />
                                </div>
                                <Text4 className="mr-1">{account.label}</Text4>
                                <Text4 className="mr-1">·</Text4>
                                <Text4 type="secondary">Available Balance: {printRupee(account.balance, 3)}</Text4>
                            </div>
                        </Select.Option>
                    ) : null
                }
            </Select>
        )
    };

    const renderPayableAmount = () => {
        const formData = form.getFieldsValue();
        let total_amount = 0
        if (formData.income_tax || formData.surcharge || formData.education_cess || formData.equilization_levy || formData.interest || formData.other_fee || formData.penalty || formData.other_amount) {
            total_amount = total_amount + parseFloat(formData.income_tax) || 0;
            total_amount = total_amount + parseFloat(formData.surcharge) || 0;
            total_amount = total_amount + parseFloat(formData.education_cess) || 0;
            total_amount = total_amount + parseFloat(formData.equilization_levy) || 0;
            total_amount = total_amount + parseFloat(formData.interest) || 0;
            total_amount = total_amount + parseFloat(formData.other_fee) || 0;
            total_amount = total_amount + parseFloat(formData.penalty) || 0;
            total_amount = total_amount + parseFloat(formData.other_amount) || 0;
            return (parseFloat(total_amount || 0));
        }
        return 0;
    };

    useEffect(() => {
        fetchDirectTaxTAXCategories()
        let vas = []
        if ((props.user || {}).key) {
            if (props.direct_tax && props.user.atdpvcc) {
                vas = props.user.virtual_accounts.map((va) => { if (va.provider_code == 'ICICI') { return va } }).filter((e) => { if (typeof (e) != undefined) return e }) || []
                setVirtualAccounts(vas)
            } else {
                vas = props.user.virtual_accounts.map((va) => { if (va.provider_code == 'ICICI' && va.funding_via == 1) { return va } }).filter((e) => { if (typeof (e) != undefined) return e }) || []
                setVirtualAccounts(vas)
            }
        }
    }, []);

    const SelectChallanType = () => {
        return (
            <div className={`row justify-content-center position-relative ${currentStep != 0 ? "d-none" : ""}`} >
                <div className="position-absolute d-flex align-items-center" style={{ left: 15, bottom: 14, top: 0 }}>
                    <div className="prev-button">
                        <Tooltip title="Previous">
                            <Button
                                type="primary"
                                onClick={() => {
                                    setCurrentStep(0);
                                }}
                                icon="left"
                                shape="circle"
                                disabled
                            />
                        </Tooltip>
                    </div>
                </div>
                <div className="col-10">
                    <Card style={{ minHeight: 430 }}>
                        <Form.Item label="Challan Type:">
                            {getFieldDecorator("challan_number", {
                                initialValue: direct_tax.challan_number || '281',
                                rules: validations.challan_number,
                            })(

                                <Radio.Group >
                                    {Object.keys(CHALLAN_NUMBER_CHOICES).map((challan) => {
                                        return (
                                            <AccountCard className='ml-2'>
                                                <Radio value={challan}>
                                                    <div className='d-flex flex-column ml-4'>
                                                        <Text4 strong>{CHALLAN_NUMBER_CHOICES[challan].label}</Text4>
                                                        <Text4 type='secondary'>{CHALLAN_NUMBER_CHOICES[challan].detail}</Text4>
                                                    </div>
                                                </Radio>
                                            </AccountCard>
                                        )
                                    })}
                                </Radio.Group>
                            )}
                        </Form.Item>
                    </Card>
                </div>
                <div className="position-absolute d-flex align-items-center" style={{ right: 15, bottom: 14, top: 0 }}>
                    <div className="next-button">
                        <Tooltip title="Next">
                            <Button
                                type="primary"
                                onClick={() => {
                                    form.validateFields(
                                        ["challan_number"],
                                        {},
                                        (err) => {
                                            if (!err) {
                                                setCurrentStep(1);
                                            }
                                        }
                                    );
                                }}
                                icon="right"
                                shape="circle"
                            />
                        </Tooltip>
                    </div>
                </div>
            </div>
        )
    }

    const FillingDetails = () => {
        return (
            <div className={`row justify-content-center position-relative ${currentStep != 1 ? "d-none" : ""}`} >
                <div className="position-absolute d-flex align-items-center" style={{ left: 15, bottom: 14, top: 0 }}>
                    <div className="prev-button">
                        <Tooltip title="Previous">
                            <Button
                                type="primary"
                                onClick={() => {
                                    setCurrentStep(0);
                                }}
                                icon="left"
                                shape="circle"
                            />
                        </Tooltip>
                    </div>
                </div>
                <div className="col-10">

                    <Card style={{ minHeight: 430 }}>
                        {getFieldDecorator("pan", {
                            initialValue: direct_tax.pan || props.user.profile.pan,
                            rules: validations.pan,
                        })(<Input autoComplete="off" hidden />)}

                        {getFieldDecorator("tan", {
                            initialValue: direct_tax.tan || props.user.profile.tan,
                            rules: validations.tan,
                        })(<Input autoComplete="off" hidden />)}

                        {getFieldDecorator("pincode", {
                            initialValue: direct_tax.pincode || props.user.profile.pincode,
                            rules: validations.pincode,
                        })(<Input autoComplete="off" hidden />)}

                        {getFieldDecorator("state", {
                            initialValue: direct_tax.state || props.user.profile.state,
                            rules: validations.state,
                        })(<Input autoComplete="off" hidden />)}
                        <Form.Item label="Tax Applicable:">
                            {getFieldDecorator("major_head", {
                                initialValue: direct_tax.major_head || "",
                                rules: validations.major_head,
                            })(
                                <Radio.Group name="major_head" >
                                    <Radio value={'0020'}>Company Deductees (0020)</Radio>
                                    <Radio value={'0021'}>Non-Company Deductees (0021)</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>
                        <Form.Item label="Tax Type:">
                            {getFieldDecorator("minor_head", {
                                initialValue: direct_tax.minor_head,
                                rules: validations.minor_head,
                            })(
                                <Select allowClear placeholder="Select Tax Type">
                                    <Option value="200">Payable By Taxpayer (200)</Option>
                                    <Option value="400">Regular Assessment (400)</Option>
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="Tax Category:">
                            {getFieldDecorator("nature_of_payment", {
                                initialValue: direct_tax.tax_category_id,
                                rules: validations.nature_of_payment,
                            })(
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Tax Category"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        return option.props.label
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    }
                                >
                                    {taxCatgories.map((category) => {
                                        return <Option value={category.id} label={category.code}>
                                            <div className='d-flex flex-column'>
                                                <Text4 strong>{category.code} {category.tax_percentage > 0 ? `(${category.tax_percentage}%)` : null} </Text4>
                                                <Text4 type='secondary' >{category.description}</Text4>
                                            </div>
                                        </Option>
                                    }
                                    )}
                                </Select>
                            )}

                        </Form.Item>
                        <Form.Item label="Assessment Year:">
                            {getFieldDecorator("assessment_year", {
                                initialValue: direct_tax.assessment_year,
                                rules: validations.assessment_year,
                            })(
                                <Select allowClear placeholder="Select Assessment Year">
                                    {ASSESSMENT_YEAR.map((year) => {
                                        return <Option value={year} label={year}>{year}</Option>
                                    })
                                    }
                                </Select>
                            )}
                        </Form.Item>
                    </Card>
                </div>
                <div className="position-absolute d-flex align-items-center" style={{ right: 15, bottom: 14, top: 0 }}>
                    <div className="next-button">
                        <Tooltip title="Next">
                            <Button
                                type="primary"
                                onClick={() => {
                                    form.validateFields(
                                        ["major_head", "issue_date", "minor_head", "assessment_year", "nature_of_payment"],
                                        {},
                                        (err) => {
                                            if (!err) {
                                                setCurrentStep(2);
                                            }
                                        }
                                    );
                                }}
                                icon="right"
                                shape="circle"
                            />
                        </Tooltip>
                    </div>
                </div>
            </div>
        )
    }

    const PaymentDetails = () => {
        return (
            <div className={`row justify-content-center position-relative ${currentStep != 2 ? "d-none" : ""}`} >
                <div className="position-absolute d-flex align-items-center" style={{ left: 15, bottom: 14, top: 0 }}>
                    <div className="prev-button">
                        <Tooltip title="Previous">
                            <Button
                                type="primary"
                                onClick={() => {
                                    setCurrentStep(1);
                                }}
                                icon="left"
                                shape="circle"
                            />
                        </Tooltip>
                    </div>
                </div>
                <div className="col-10">

                    <Card style={{ minHeight: 430 }}>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Tax Amount:">
                                    {getFieldDecorator("income_tax", {
                                        initialValue: direct_tax.income_tax ? Number(direct_tax.income_tax) : 0,
                                        rules: validations.income_tax,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Interest:">
                                    {getFieldDecorator("interest", {
                                        initialValue: direct_tax.interest ? Number(direct_tax.interest) : 0,
                                        rules: validations.interest,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Surcharge:">
                                    {getFieldDecorator("surcharge", {
                                        initialValue: direct_tax.surcharge ? Number(direct_tax.surcharge) : 0,
                                        rules: validations.surcharge,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Education Cess:">
                                    {getFieldDecorator("education_cess", {
                                        initialValue: direct_tax.education_cess ? Number(direct_tax.education_cess) : 0,
                                        rules: validations.education_cess,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Other Fee:">
                                    {getFieldDecorator("other_fee", {
                                        initialValue: direct_tax.other_fee ? Number(direct_tax.other_fee) : 0,
                                        rules: validations.other_fee,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Other Amount:">
                                    {getFieldDecorator("other_amount", {
                                        initialValue: direct_tax.other_amount ? Number(direct_tax.other_amount) : 0,
                                        rules: validations.other_amount,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Penalty:">
                                    {getFieldDecorator("penalty", {
                                        initialValue: direct_tax.penalty ? Number(direct_tax.penalty) : 0,
                                        rules: validations.penalty,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            onChange={(e) => { return e == 0 ? form.setFieldsValue({ 'penalty_code': '' }) : null }}
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Penalty Code:">
                                    {getFieldDecorator("penalty_code", {
                                        initialValue: direct_tax.penalty_code,
                                        rules: validations.penalty_code,
                                    })(
                                        <Radio.Group name="penalty_code" disabled={((form.getFieldValue('penalty') != 0) && (direct_tax.penalty != 0)) ? false : true} >
                                            <Radio value={'11C'}>11C</Radio>
                                            <Radio value={'N11C'}>N11C</Radio>
                                        </Radio.Group>
                                    )}

                                </Form.Item>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Equilization Levy:">
                                    {getFieldDecorator("equilization_levy", {
                                        initialValue: direct_tax.equilization_levy ? Number(direct_tax.equilization_levy) : 0,
                                        rules: validations.equilization_levy,
                                    })(
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            autoComplete="off"
                                            prefix={
                                                <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6">
                                <Form.Item label="Total Amount:">
                                    {getFieldDecorator("total_amount", {
                                        initialValue: direct_tax.total_amount || 0,
                                        rules: validations.total_amount,
                                    })(printRupee(renderPayableAmount()))}
                                </Form.Item>
                            </div>
                        </div>
                    </Card>
                </div>
                <div className="position-absolute d-flex align-items-center" style={{ right: 15, bottom: 14, top: 0 }}>
                    <div className="next-button">
                        <Tooltip title="Next">
                            <Button
                                type="primary"
                                onClick={() => {
                                    form.validateFields(
                                        ["income_tax", "surcharge", "education_cess", "equilization_levy", "interest", "other_fee", "penalty", "penalty_code", "other_amount"],
                                        {},
                                        (err) => {
                                            if (!err) {
                                                setCurrentStep(3);
                                            }
                                        }
                                    );
                                }}
                                icon="right"
                                shape="circle"
                            />
                        </Tooltip>
                    </div>
                </div>
            </div>
        )
    }

    const FinalDirectTaxChallan = () => {
        return (
            <div className={`row justify-content-center position-relative ${currentStep != 3 ? "d-none" : ""}`} >
                <div className="position-absolute d-flex align-items-center" style={{ left: 15, bottom: 14, top: 0 }}>
                    <div className="prev-button">
                        <Tooltip title="Previous">
                            <Button
                                type="primary"
                                onClick={() => {
                                    setCurrentStep(2);
                                }}
                                icon="left"
                                shape="circle"
                            />
                        </Tooltip>
                    </div>
                </div>
                <div className="col-10">
                    <Card style={{ minHeight: 430 }}>
                        <Descriptions
                            selectedVendorProfile
                            title={false}
                            column={2}
                            bordered
                            // style={{ backgroundColor: "#fff" }}
                            size="small"
                        >
                            <Descriptions.Item label="Challan Number">{CHALLAN_NUMBER_CHOICES[form.getFieldValue('challan_number')].label}</Descriptions.Item>
                            <Descriptions.Item label="Tax Applicable">{form.getFieldValue('major_head') ? MAJOR_HEAD_CHOICES[form.getFieldValue('major_head')].label : '---'}</Descriptions.Item>
                            <Descriptions.Item label="PAN">{form.getFieldValue('pan')}</Descriptions.Item>
                            <Descriptions.Item label="TAN">{form.getFieldValue('tan')}</Descriptions.Item>
                            <Descriptions.Item label="Tax Type">{form.getFieldValue('minor_head') ? MINOR_HEAD_CHOICES[form.getFieldValue('minor_head')].label : '---'}</Descriptions.Item>
                            <Descriptions.Item label="Assessment Year">{form.getFieldValue('assessment_year')}</Descriptions.Item>
                            <Descriptions.Item label="Tax Category">{form.getFieldValue('nature_of_payment') ?
                                (taxCatgories.map((category) => {
                                    if (category.id == form.getFieldValue('nature_of_payment')) {
                                        return <div className='d-flex'>
                                            <Text4 className='d-block mr-1' strong>{category.code} ({category.tax_percentage}%)</Text4>
                                            <Text4 type='secondary'>{category.description}</Text4>
                                        </div>
                                    }
                                })) : '---'
                            }</Descriptions.Item>
                        </Descriptions>
                        <div className='row'>
                            <div className='col-6'>
                                <Descriptions
                                    className="mt-3"
                                    selectedVendorProfile
                                    title={false}
                                    column={1}
                                    bordered
                                    size="small"
                                >
                                    <Descriptions.Item label="Tax Amount">
                                        {printRupee(form.getFieldValue('income_tax'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Surcharge">
                                        {printRupee(form.getFieldValue('surcharge'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Education cess">
                                        {printRupee(form.getFieldValue('education_cess'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Equilization levy">
                                        {printRupee(form.getFieldValue('equilization_levy'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Interest">
                                        {printRupee(form.getFieldValue('interest'))}
                                    </Descriptions.Item>

                                </Descriptions>
                            </div>
                            <div className='col-6'>
                                <Descriptions
                                    className="mt-3"
                                    selectedVendorProfile
                                    title={false}
                                    column={1}
                                    bordered
                                    size="small"
                                >
                                    <Descriptions.Item label={`Penalty (Code:${form.getFieldValue('penalty_code') ? form.getFieldValue('penalty_code') : 'NA'})`}>
                                        {printRupee(form.getFieldValue('penalty'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Other fee">
                                        {printRupee(form.getFieldValue('other_fee'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Other Amount">
                                        {printRupee(form.getFieldValue('other_amount'))}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Total amount">
                                        {printRupee(renderPayableAmount())}
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </div>

                        <div className="mt-2">
                            {getFieldDecorator("initiate_payment", {
                                valuePropName: "checked",
                                initialValue: false,
                            })(<Checkbox>Initiate Payment Now</Checkbox>)}
                        </div>
                        {
                            form.getFieldValue('initiate_payment') ? (
                                <div className="mt-3">
                                    <Form.Item label="Source Virtual Account">
                                        {getFieldDecorator("virtual_account_id", {
                                            rules: [{ required: true, message: "Please select the source account." }],
                                        })(renderAccounts())}
                                    </Form.Item>
                                </div>
                            ) : null
                        }
                        <div className="w-100 d-flex justify-content-center mt-4">
                            <Button loading={isSaving} type="primary" onClick={onSubmit}>
                                {form.getFieldValue("initiate_payment")
                                    ? "Initiate Payment"
                                    : "Save"}
                            </Button>
                        </div>
                    </Card>
                </div >
            </div >
        )
    }

    const renderSteps = () => {
        return (
            <div className="mb-4">
                <Steps current={currentStep}>
                    <Steps.Step
                        title={<Text4>Select Challan</Text4>}
                        status={currentStep >= 0 ? "finish" : ""}
                        onClick={() => { if (currentStep >= 0) setCurrentStep(0); }}
                    // icon={<Icon type="user" />}
                    />
                    <Steps.Step
                        title={<Text4>Filling Details</Text4>}
                        status={currentStep >= 1 ? "finish" : ""}
                        onClick={() => { if (currentStep >= 1) setCurrentStep(1); }}
                    // icon={<Icon type="user" />}
                    />
                    <Steps.Step
                        title={<Text4>Tax Amount</Text4>}
                        status={currentStep >= 2 ? "finish" : ""}
                        onClick={() => { if (currentStep >= 2) setCurrentStep(2); }}
                    // icon={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />}
                    />
                    <Steps.Step
                        title={<Text4>Review & Pay</Text4>}
                        status={currentStep >= 3 ? "finish" : ""}
                        onClick={() => { if (currentStep >= 3) setCurrentStep(3); }}
                    // icon={<Icon type="bank" />}
                    />
                </Steps>
            </div>
        )
    };



    return (
        <>
            {renderSteps()}
            <Form >
                {SelectChallanType()}
                {FillingDetails()}
                {PaymentDetails()}
                {FinalDirectTaxChallan()}
            </Form>
        </>


    )

};

DirectTaxForm = Form.create()(DirectTaxForm);
export { DirectTaxForm };